<template>
    <section>
        <div class="ct-box">
            <div class="form">
                <div class="inputbox">
                    <label>公司名称</label>
                    <input type="text" name="companyName" v-model="clientDetail.company" placeholder="公司名称必须填写" style="margin-top:54px;" id="input-company">
                </div>
                <div class="inputbox">
                    <label>公司地址</label>
                    <input type="text" name="address" v-model="clientDetail.address" placeholder="公司地址必须填写" id='input-ad'>
                </div>
                <div class="inputbox">
                    <label style="margin-left:37px;margin-right:76px">联系人</label>
                    <input type="text" name="people" v-model="clientDetail.contacts" placeholder="联系人必须填写" id='input-people'>
                </div>
                <div class="inputbox">
                    <label>手机号码</label>
                    <input type="text" name="phone" v-model="clientDetail.mobile" placeholder="手机号码必须填写" id='input-phone'>
                </div>
                <div class="inputbox">
                    <label style="margin-left:37px;margin-right:100px">职务</label>
                    <input type="text" name="job" v-model="clientDetail.jobs" id='input-job'>
                </div>
                <div class="inputbox">
                    <label style="margin-left:37px;margin-right:100px;vertical-align: middle;">留言</label>
                    <textarea v-model="clientDetail.desc"
                            id="input-rewrite"
                    ></textarea>
                </div>
            </div>
        </div>
        <div style="text-align:center;">
            <button class="btn" v-on:click="nextStep">
                下一步
            </button>
        </div>
    </section>
</template>

<script>
    import cookie from 'vue-cookie'
    export default {
        name: "Client",
        beforeRouteEnter(to, from, next) {
            if(cookie.get('erp_tk') && cookie.get('erp_st')) {
                switch (cookie.get('erp_st')) {
                    case '2':
                        next({ path:'/site_config' })
                        break
                    case '3':
                        next({ path: '/pay_meal' })
                        break
                    case '4':
                        next({ path: '/build_site'})
                        break
                    default:
                        next(true)
                        break
                }

            } else {
                next(true)
            }
        },
        data: function() {
            return {
                clientDetail: {
                    company: '',
                    address: '',
                    contacts: '',
                    mobile: '',
                    jobs: '',
                    desc: ''
                },
                apiDomain: 'http://wechat.lixun365.com',
            }
        },
        created: function() {

        },
        methods: {
            nextStep: function () {
                this.$axios.post(this.apiDomain + '/api/site.site/postclientdetail', this.clientDetail)
                    .then((res) => {
                        if(res.data.code === 1001) {
                            this.$cookie.set('erp_st', res.data.data.step, {expires: '1D'})
                            if(res.data.data.step === 3) {
                                this.$cookie.set('erp_tk', res.data.data.ticket, {expires: '1D'})
                                this.$router.push({name: 'payMeal'})
                            } else if(res.data.data.step === 4) {
                                res.data.data.domain.length > 0 && this.$cookie.set('s_domain', res.data.data.domain, {expires: '1d'})
                                this.$cookie.set('erp_tk', res.data.data.ticket, {expires: '7200s'})
                                this.$router.push({name: 'buildSite'})
                            } else {
                                this.$cookie.set('erp_tk', res.data.data.ticket, {expires: '1D'})
                                this.$router.push({name: 'siteConfig'})
                            }
                        } else {
                            layer.msg(res.data.msg)
                        }
                    }).catch((err) => { console.error(err) })
            },
        }
    }
</script>